import React from "react";
import { SideMenu, Model, DateRangePicker } from "./../../components";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import { Button } from "@mui/material";
import Countries from "./../../../data/countries";
import Pagination from "@mui/material/Pagination";
import Stack from "@mui/material/Stack";
import "./add-staff.css";
import { BsFillChatDotsFill } from "react-icons/bs";
import { HiOutlineUpload } from "react-icons/hi";
import { IoMdAnalytics } from "react-icons/io";
import { useAlert } from "react-alert";
import { useNavigate } from "react-router-dom";
const AddStaff = () => {
  const alert = useAlert();
  const navigate = useNavigate();
  const [invite, setInvite] = React.useState(false);
  const State = [
    {
      title: "Balochistan",
    },
    {
      title: "Punjab",
    },
    {
      title: "Sindh",
    },
    {
      title: "KPK",
    },
  ];
  const [TableData, setTableData] = React.useState([
    {
      date: "JAN 4, 2022",
      staffName: "Willow Anderson",
      country: "burnside",
      state: "burnside",
      city: "burnside",
      email: "WillowAnderson@gmail.com",
      phone: "1234567890",
      role: "Teacher",
      status: "Active",
    },
    {
      date: "JAN 4, 2022",
      staffName: "Henry O'Brien",
      country: "burnside",
      state: "burnside",
      city: "burnside",
      email: "HenryOBrien@gmail.com",
      phone: "1234567890",
      role: "Teacher",
      status: "Active",
    },
    {
      date: "JAN 4, 2022",
      staffName: "Willow Anderson",
      country: "burnside",
      state: "burnside",
      city: "burnside",
      email: "WillowAnderson@gmail.com",
      phone: "1234567890",
      role: "Teacher",
      status: "Deactive",
    },
    {
      date: "JAN 4, 2022",
      staffName: "Henry O'Brien",
      country: "burnside",
      state: "burnside",
      city: "burnside",
      email: "HenryOBrien@gmail.com",
      phone: "1234567890",
      role: "Teacher",
      status: "Active",
    },
    {
      date: "JAN 4, 2022",
      staffName: "Willow Anderson",
      country: "burnside",
      state: "burnside",
      city: "burnside",
      email: "WillowAnderson@gmail.com",
      phone: "1234567890",
      role: "Teacher",
      status: "Deactive",
    },
    {
      date: "JAN 4, 2022",
      staffName: "Henry O'Brien",
      country: "burnside",
      state: "burnside",
      city: "burnside",
      email: "HenryOBrien@gmail.com",
      phone: "1234567890",
      role: "Teacher",
      status: "Active",
    },
    {
      date: "JAN 4, 2022",
      staffName: "Willow Anderson",
      country: "burnside",
      state: "burnside",
      city: "burnside",
      email: "WillowAnderson@gmail.com",
      phone: "1234567890",
      role: "Teacher",
      status: "Deactive",
    },
  ]);
  const handleStatusDropdownChange = (event, tableIndex) => {
    TableData[tableIndex].status = event.target.value;
    setTableData([...TableData]);
  };

  const EditHander = (e) => {
    if (e.target.value === "Edit") {
      navigate("/add-staff/add", {
        state: { type: "edit" },
      });
    }
  };

  // Invite Staff
  const [inviteStaffName, setInviteStaffName] = React.useState("");
  const [inviteStaffEmail, setInviteStaffEmail] = React.useState("");
  const [inviteStaffLoading, setInviteStaffLoading] = React.useState(false);
  const inviteStaffNameRef = React.useRef();
  const inviteStaffEmailRef = React.useRef();
  const InviteStaffHandler = () => {
    if (inviteStaffName === "") {
      alert.error(<div className="alert-message">name required</div>);
      inviteStaffNameRef.current.focus();
    } else if (inviteStaffEmail === "") {
      alert.error(
        <div className="alert-message">please type valid email address</div>
      );
      inviteStaffEmailRef.current.focus();
    } else {
      setInviteStaffLoading(true);
      const InviteStaffObject = {
        fullName: inviteStaffName,
        email: inviteStaffEmail,
      };
      alert.success(
        <div className="alert-message">you have successfully invited</div>
      );
      console.log(InviteStaffObject);
      setTimeout(() => {
        setInvite(false);
        setInviteStaffLoading(false);
      }, 2000);
    }
  };
  return (
    <SideMenu>
      <div className="page-container">
        <Box sx={{ flexGrow: 1 }}>
          <Grid container spacing={2}>
            <Grid item xl={6} lg={6} md={6} sm={12} xs={12}></Grid>
            <Grid item xl={2} lg={2} md={2} sm={4} xs={12}>
              <Button
                className="header-button"
                variant="text"
                onClick={() => setInvite(true)}
              >
                <p className="page-header-button-text">Invite Staff</p>
              </Button>
            </Grid>
            <Grid item xl={2} lg={2} md={2} sm={4} xs={12}>
              <Button className="header-button" variant="text">
                <HiOutlineUpload />{" "}
                <p className="page-header-button-text"> Upload file</p>
              </Button>
            </Grid>
            <Grid item xl={2} lg={2} md={2} sm={4} xs={12}>
              <Button
                className="header-button"
                variant="text"
                onClick={() => {
                  navigate("/add-staff/add", {
                    state: { type: "add" },
                  });
                }}
              >
                <p className="page-header-button-text">Add Staff</p>
              </Button>
            </Grid>
          </Grid>
        </Box>

        <Box sx={{ flexGrow: 1 }}>
          <Grid container spacing={2}>
            <Grid item xl={2} lg={3} md={3} sm={7} xs={12}>
              <div>
                <p className="header-input-heading">Search by course Name</p>
                <input
                  type="text"
                  className="header-input"
                  placeholder="Search by course Name"
                />
              </div>
            </Grid>
            <Grid item xl={2} lg={3} md={3} sm={5} xs={12}>
              <div>
                <p className="header-input-heading">Role</p>
                <input
                  type="text"
                  className="header-input"
                  placeholder="Search By Role"
                />
              </div>
            </Grid>
            <Grid item xl={2} lg={2} md={2} sm={4} xs={12}>
              <div>
                <p className="header-input-heading">Country</p>
                <select className="header-dropdown">
                  <option value="">Select</option>
                  <option value="all">All</option>
                  {Countries.map((countriesValue, countriesIndex) => {
                    return (
                      <option key={countriesIndex} value={countriesValue.name}>
                        {countriesValue.name}
                      </option>
                    );
                  })}
                </select>
              </div>
            </Grid>
            <Grid item xl={2} lg={2} md={2} sm={4} xs={12}>
              <div>
                <p className="header-input-heading">State</p>
                <select className="header-dropdown">
                  <option value="">Select</option>
                  <option value="all">All</option>
                  {State.map((stateValue, stateIndex) => {
                    return (
                      <option key={stateIndex} value={stateValue.title}>
                        {stateValue.title}
                      </option>
                    );
                  })}
                </select>
              </div>
            </Grid>
            <Grid item xl={2} lg={2} md={2} sm={4} xs={12}>
              <div>
                <p className="header-input-heading">City</p>
                <select className="header-dropdown">
                  <option value="">Select</option>
                  <option value="all">All</option>
                  {State.map((stateValue, stateIndex) => {
                    return (
                      <option key={stateIndex} value={stateValue.title}>
                        {stateValue.title}
                      </option>
                    );
                  })}
                </select>
              </div>
            </Grid>
            <Grid item xl={2} lg={2} md={2} sm={4} xs={12}>
              <div>
                <p className="header-input-heading">Status</p>
                <select className="header-dropdown">
                  <option value="">Select</option>
                  <option value="all">All</option>
                  <option value="Complated">Complated</option>
                  <option value="Rejected">Rejected</option>
                </select>
              </div>
            </Grid>
            <Grid item xl={3} lg={3} md={4} sm={6} xs={12}>
              <DateRangePicker />
            </Grid>
            <Grid item xl={2} lg={2} md={2} sm={2} xs={12}>
              <Button className="header-apply-button" variant="text">
                <p className="header-apply-button-text">Apply</p>
              </Button>
            </Grid>
            <Grid item xl={7} lg={7} md={6} sm={6} xs={12}></Grid>
          </Grid>
        </Box>
        <br />
        <div className="table-container">
          <div className="table-header">
            <p className="table-heading">Staff</p>
          </div>
          <div className="table-data-container">
            <table>
              <thead>
              <tr>
                <th className="add-staff-table-date-heading">Date</th>
                <th className="add-staff-table-staff-name-heading">
                  Staff Name
                </th>
                <th className="add-staff-table-country-heading">country</th>
                <th className="add-staff-table-state-heading">state</th>
                <th className="add-staff-table-city-heading">city</th>
                <th className="add-staff-table-email-heading">Email</th>
                <th className="add-staff-table-phone-number-heading">Phone</th>
                <th className="add-staff-table-phone-role-heading">Role</th>
                <th className="add-staff-table-phone-status-heading">Status</th>
                <th className="add-staff-table-phone-chat-heading">Chat</th>
                <th className="add-staff-table-phone-action-heading"></th>
                <th className="add-staff-table-phone-analytics-heading"></th>
              </tr>
              </thead>
              {TableData.map((tableValue, tableIndex) => {
                return (
                  <tr key={tableIndex}>
                    <td className="table-date-data">{tableValue.date}</td>
                    <td className="table-data">{tableValue.staffName}</td>
                    <td className="table-data">{tableValue.country}</td>
                    <td className="table-data">{tableValue.state}</td>
                    <td className="table-data">{tableValue.city}</td>
                    <td className="table-email-data">{tableValue.email}</td>
                    <td className="table-data">{tableValue.phone}</td>
                    <td className="table-data">{tableValue.role}</td>
                    <td className="table-data">
                      <select
                        className="table-status-dropdown"
                        style={{
                          backgroundColor:
                            tableValue.status === "Deactive"
                              ? "#FFB0B0"
                              : "#D2FFEB",
                          color:
                            tableValue.status === "Deactive"
                              ? "#B80000"
                              : "#098B51",
                        }}
                        onChange={(e) =>
                          handleStatusDropdownChange(e, tableIndex)
                        }
                      >
                        <option
                          value="Active"
                          selected={
                            tableValue.status === "Active" && "selected"
                          }
                        >
                          Active
                        </option>
                        <option
                          value="Deactive"
                          selected={
                            tableValue.status === "Deactive" && "selected"
                          }
                        >
                          Deactive
                        </option>
                      </select>
                    </td>
                    <td className="table-data">
                      <Button
                        className="table-analytics-chat-button"
                        onClick={() => navigate("/chat")}
                      >
                        <BsFillChatDotsFill color="#663399" size={20} />
                      </Button>
                    </td>
                    <td className="table-data">
                      <select
                        className="table-action-dropdown"
                        onChange={EditHander}
                      >
                        <option value="">Action</option>
                        <option value="Edit">Edit</option>
                        <option value="Delete">Delete</option>
                      </select>
                    </td>
                    <td className="table-data">
                      <Button
                        className="table-analytics-chat-button"
                        onClick={() => navigate("/add-staff/analytics")}
                      >
                        <IoMdAnalytics color="#663399" size={20} />
                      </Button>
                    </td>
                  </tr>
                );
              })}
            </table>
          </div>
          <div className="table-pagination-main">
            <Stack spacing={2}>
              <Pagination count={10} variant="outlined" shape="rounded" />
            </Stack>
          </div>
        </div>
      </div>
      <Model
        modelTitle="Invite Staff"
        width="md"
        onClose={() => setInvite(false)}
        open={invite}
        buttonTitle="invite send"
        buttonHandler={InviteStaffHandler}
        loading={inviteStaffLoading}
      >
        <div className="form-container">
          <Box sx={{ flexGrow: 1 }}>
            <Grid container spacing={2}>
              <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
                <div>
                  <p className="input-heading">Name</p>
                  <input
                    type="text"
                    name="fullName"
                    className="input"
                    placeholder="Name"
                    value={inviteStaffName}
                    ref={inviteStaffNameRef}
                    onChange={(e) => setInviteStaffName(e.target.value)}
                  />
                </div>
              </Grid>
              <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
                <div>
                  <p className="input-heading">Email Address</p>
                  <input
                    type="email"
                    name="email"
                    require="required"
                    className="input"
                    placeholder="Email Address"
                    value={inviteStaffEmail}
                    ref={inviteStaffEmailRef}
                    onChange={(e) => setInviteStaffEmail(e.target.value)}
                  />
                </div>
              </Grid>
            </Grid>
          </Box>
        </div>
      </Model>
    </SideMenu>
  );
};
export default AddStaff;
